const NO_BIRTH_TAGS = ['no birth data', 'fixed graphic', 'fixed chart'];
const NO_BIRTH_TYPES = ['fixed graphic', 'builder hoodie'];

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', hideIrrelevantBirthFields, { once: true });
} else {
  hideIrrelevantBirthFields();
}

async function hideIrrelevantBirthFields() {
  const handle = location.pathname.match(/\/products\/([^/?#]+)/)?.[1];
  if (!handle) return;

  const product = await fetchProduct(handle);
  if (!product || requiresBirthData(product)) return;

  for (const block of document.querySelectorAll('product-custom-property-component')) {
    disableAndHide(block);
  }

  for (const intro of document.querySelectorAll('rte-formatter')) {
    if (intro.textContent?.toLowerCase().includes('birth details')) {
      intro.hidden = true;
    }
  }

  for (const gate of document.querySelectorAll('birth-data-gate')) {
    gate.hidden = true;
  }
}

async function fetchProduct(handle) {
  try {
    const response = await fetch(`/products/${handle}.js`, { cache: 'force-cache' });
    return response.ok ? await response.json() : null;
  } catch (error) {
    console.warn('[starlyzed-birth-fields] Could not load product JSON:', error);
    return null;
  }
}

function requiresBirthData(product) {
  const tags = normalizeTags(product.tags);
  const type = (product.type ?? '').toLowerCase();

  if (tags.includes('birth data required')) return true;
  if (NO_BIRTH_TAGS.some((tag) => tags.includes(tag))) return false;
  if (NO_BIRTH_TYPES.some((productType) => type.includes(productType))) return false;

  return true;
}

function normalizeTags(tags) {
  if (Array.isArray(tags)) return tags.join(',').toLowerCase();
  return String(tags ?? '').toLowerCase();
}

function disableAndHide(block) {
  for (const field of block.querySelectorAll('input, textarea, select')) {
    field.required = false;
    field.disabled = true;
    field.removeAttribute('required');
    field.removeAttribute('aria-required');
    field.removeAttribute('name');
  }

  block.hidden = true;
}
